"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinanceFutureMarginCalculator = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const GridTradingUtils_1 = require("../../GridTrading/GridTradingUtils");
class BinanceFutureMarginCalculator {
    constructor(tradeAPI, symbol) {
        this.isFullPosition = false;
        this.isReady = false;
        this.tradeAPI = tradeAPI;
        this.symbol = symbol;
        this.updateExchangeConfigureConfigure();
    }
    getFutureMarginInfo(top, bottom, count, trend, gridType, invest, curPrice, triggerPrice, leverageRate, fee) {
        var _a;
        const maxLeverageRate = this.getMaxLeverage();
        const maxPosition = this.getMaxPosition(leverageRate);
        const gridBaseInvest = '0'; // 运行网格的base资金
        const gridQuoteInvest = invest; // 运行网格的quote资金
        const openPrice = triggerPrice || curPrice;
        const perVolume = GridTradingUtils_1.GridTradingUtils.getPerGridValume(top, bottom, count, gridBaseInvest, gridQuoteInvest, openPrice, gridType, trend);
        const perVolumeStr = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(perVolume, this.symbol.amount);
        const marginRate = new trade_utils_lib_1.SafeDecimal(1).div(leverageRate).toString();
        const maintenance = ((_a = this.symbolConfigure) === null || _a === void 0 ? void 0 : _a.maintenance_margin_levels) || [];
        const liquidationPrice = this.calculateGridLiquidationPrice(top, bottom, count, openPrice, perVolumeStr, trend, maintenance, marginRate, fee, gridType, this.symbol);
        return {
            maxLeverageRate: maxLeverageRate,
            maxPosition: maxPosition,
            liquidationPrice: liquidationPrice
        };
    }
    updateExchangeConfigureConfigure() {
        this.isReady = false;
        (0, trade_utils_lib_1.requestWithRetry)(() => {
            return this.tradeAPI.requestBinanceLeverageConfigures("binance");
        }, { name: "requestBinanceLeverageConfigures" })
            .subscribe(data => {
            if (data) {
                const leverage_level = data.leverage_levels.find((value) => {
                    const findKey = `${this.symbol.base}_${this.symbol.quote}`;
                    const index = value.symbols.indexOf(findKey);
                    return index >= 0;
                });
                if (leverage_level) {
                    this.symbolConfigure = leverage_level;
                    this.isReady = true;
                }
                else {
                    console.log(`BinanceFutureMarginCalculator leverage_configs.json not get symbol: ${this.symbol.symbol}`);
                }
            }
            else {
                console.log(`BinanceFutureMarginCalculator leverage_configs.json not get`);
            }
        }, error => {
            console.log(error);
        });
    }
    getMaxLeverage() {
        if (!this.symbolConfigure || !this.isReady) {
            return;
        }
        return this.symbolConfigure.max_leverage;
    }
    getMaxPosition(curLeverageRate) {
        if (!this.symbolConfigure || !this.isReady) {
            return;
        }
        const configs = this.symbolConfigure.max_position_levels.sort((a, b) => { return b.leverage - a.leverage; });
        let value = undefined;
        for (let i = 0; i < configs.length; i++) {
            const positionConfig = configs[i];
            if (curLeverageRate <= positionConfig.leverage) {
                value = positionConfig.value || 0;
            }
            else {
                break;
            }
        }
        return value;
    }
    // 强行平仓会发生在：
    // 保证金余额=初始抵押资金+实现盈亏+未实现盈亏＜维持保证金
    // open_price 平均开仓价
    // margin_balance 保证金
    // maintenance_margin 维持保证金
    // position 持仓, 合约中单指base的数量
    // margin_balance >= maintenance_margin
    //保证金 = 初始保证金 + 浮动盈亏
    // margin_balance = init_margin + unrealized_profit 
    //init_margin_rate 本金所占的比例(比如十倍杠杆, 本金比例就是10%)
    //charged_margin 追加保证金(前端开单时没有)
    //初始保证金 = (开仓价 * 持仓 * 开仓时本金所占的比例) - 手续费 + 追加保证金
    // init_margin = (open_price * abs(position) * init_margin_rate) + (-fee + charged_margin)
    // 未实现利润(浮动盈亏) = (当前价-开单价)*持仓
    // unrealized_profit = (current_price - open_price) * position
    // 维持保证金 = 当前价格 * 当前持仓 * maintenance_rate - maintenance_x
    // maintenance_margin = current_price * abs(position) * maintenance_rate - maintenance_x
    // using position:
    // (open_price * abs(position)) + (current_price - open_price) * position + (-fee + charged_margin) <= current_price * abs(position) * maintenance_rate - maintenance_x
    // long:
    // current_price  >= (fee - charged_margin - maintenance_x + (1 - init_margin_rate) * open_price * position) / ((1 - maintenance_rate) * position)
    // short:
    // current_price <= ((fee - charged_margin - maintenance_x) + (1 + init_margin_rate) * open_price * position) / (position * (1 + maintenance_rate))
    /**
     * openPrice: 开单价
     * position: base的持仓
     * fee: 手续费
     * margin_rate: 本金占有率
     * charged_margin: 追加保证金(开单前计算为空)
    */
    static getLiquidationPrice(openPrice, position, fee, margin_rate, charged_margin, maintenance, trend) {
        const maintenanceRate = new trade_utils_lib_1.SafeDecimal(maintenance.ratio);
        const maintenanceX = new trade_utils_lib_1.SafeDecimal(maintenance.calc_n);
        if (trend === 'long') {
            const liquidation = fee.sub(charged_margin).sub(maintenanceX)
                .add(new trade_utils_lib_1.SafeDecimal(1).sub(margin_rate).mul(openPrice).mul(position))
                .div(new trade_utils_lib_1.SafeDecimal(1).sub(maintenanceRate).mul(position));
            return liquidation.toString();
        }
        else {
            const liquidation = fee.sub(charged_margin).sub(maintenanceX)
                .add(new trade_utils_lib_1.SafeDecimal(1).add(margin_rate).mul(openPrice).mul(position))
                .div(position.mul(new trade_utils_lib_1.SafeDecimal(1).add(maintenanceRate)));
            return liquidation.toString();
        }
    }
    static getLiquidationPriceMatchMaintenances(openPrice, position, fee, margin_rate, charged_margin, maintenance, trend) {
        if (maintenance.length <= 0) {
            return "";
        }
        // 按value的级别排序
        const parseMaintenance = maintenance.sort((a, b) => a.value - b.value);
        // 预估维持保证金率
        const esMaintenance = parseMaintenance[0];
        // 预估爆仓价
        const esLiquidation = this.getLiquidationPrice(openPrice, position, fee, margin_rate, charged_margin, esMaintenance, trend);
        // 预估维持保证金
        const esMaintenanceMargin = new trade_utils_lib_1.SafeDecimal(esLiquidation).mul(position.abs());
        // 推算维持保证金率
        let realMaintenance = esMaintenance;
        for (let i = 0; i < parseMaintenance.length; i++) {
            const current = parseMaintenance[i];
            const levelValue = new trade_utils_lib_1.SafeDecimal(current.value);
            // 判断是不是维持保证金
            if (esMaintenanceMargin.greaterThanOrEqualTo(levelValue)) {
                realMaintenance = current;
                continue;
            }
            else {
                break;
            }
        }
        const liquidation = this.getLiquidationPrice(openPrice, position, fee, margin_rate, charged_margin, realMaintenance, trend);
        return liquidation;
    }
    calculateGridLiquidationPrice(top, bottom, row, currentPrice, perVolume, trend, maintenance, marginRate, fee, gridType, symbol) {
        if (!Number(top) || !Number(bottom) || !Number(row) || Number(row) < 2 || Number(top) <= Number(bottom)) {
            return '';
        }
        if (!Number(perVolume) || maintenance.length <= 0 || !Number(marginRate) || !Number(currentPrice)) {
            return '';
        }
        const _perVolume = new trade_utils_lib_1.SafeDecimal(perVolume);
        const _fee = new trade_utils_lib_1.SafeDecimal(fee);
        const _marginRate = new trade_utils_lib_1.SafeDecimal(marginRate);
        const chargedMargin = new trade_utils_lib_1.SafeDecimal(0);
        const curPrice = new trade_utils_lib_1.SafeDecimal(currentPrice);
        const count = new trade_utils_lib_1.SafeDecimal(row);
        const priceArr = GridTradingUtils_1.GridTradingUtils.getPriceInterverArr(top, bottom, row, gridType);
        if (priceArr.length <= 0) {
            return "";
        }
        const curPriceIndex = GridTradingUtils_1.GridTradingUtils.findPriceIndexInArr(priceArr, curPrice.toString());
        if (trend === 'long') {
            // 计算开仓均价: 当前价格之上, 均价买入, 当前向上按格子价格买入
            let avgOpenPrice = new trade_utils_lib_1.SafeDecimal(curPrice);
            for (let i = 0; i < priceArr.length; i++) {
                // 计算开仓均价
                if (new trade_utils_lib_1.SafeDecimal(i).lessThan(curPriceIndex)) {
                    const upperSumPrice = curPrice.mul(count.sub(1).sub(new trade_utils_lib_1.SafeDecimal(curPriceIndex)));
                    let lowerSumPrice = new trade_utils_lib_1.SafeDecimal(0);
                    for (let j = i; j < curPriceIndex; j++) {
                        lowerSumPrice = lowerSumPrice.add(priceArr[j]);
                    }
                    avgOpenPrice = upperSumPrice.add(lowerSumPrice).div(new trade_utils_lib_1.SafeDecimal(priceArr.length - 1 - i));
                }
                else {
                    avgOpenPrice = new trade_utils_lib_1.SafeDecimal(curPrice);
                }
                // 看多最低价的时候为满仓, 涨一格, 平一单.
                const baseAmount = _perVolume.mul(count.sub(1).sub(i));
                const result = BinanceFutureMarginCalculator.getLiquidationPriceMatchMaintenances(avgOpenPrice, baseAmount, _fee, _marginRate, chargedMargin, maintenance, trend);
                if (new trade_utils_lib_1.SafeDecimal(result).lessThanOrEqualTo(priceArr[i])) {
                    return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(result, symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
                }
            }
            const result = BinanceFutureMarginCalculator.getLiquidationPriceMatchMaintenances(avgOpenPrice, new trade_utils_lib_1.SafeDecimal(0), _fee, _marginRate, chargedMargin, maintenance, trend);
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(result, symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        }
        else {
            // 计算开仓均价: 当前价格之下, 均价买入, 当前向上按格子价格买入
            let avgOpenPrice = new trade_utils_lib_1.SafeDecimal(curPrice);
            for (let i = 0; i < priceArr.length; i++) {
                const index = priceArr.length - 1 - i; // 倒序, 从最高价开始
                // 计算开仓均价
                if (new trade_utils_lib_1.SafeDecimal(index).greaterThan(curPriceIndex)) {
                    const lowerSumPrice = curPrice.mul(new trade_utils_lib_1.SafeDecimal(curPriceIndex));
                    let upperSumPrice = new trade_utils_lib_1.SafeDecimal(0);
                    for (let j = (curPriceIndex + 1); j <= index; j++) {
                        upperSumPrice = upperSumPrice.add(priceArr[j]);
                    }
                    avgOpenPrice = upperSumPrice.add(lowerSumPrice).div(index);
                }
                else {
                    avgOpenPrice = new trade_utils_lib_1.SafeDecimal(curPrice);
                }
                // 看空最高价的时候为满仓, 跌一格, 平一单.
                const baseAmount = _perVolume.mul(index);
                const result = BinanceFutureMarginCalculator.getLiquidationPriceMatchMaintenances(avgOpenPrice, baseAmount, _fee, _marginRate, chargedMargin, maintenance, trend);
                const gridPrice = priceArr[index];
                if (new trade_utils_lib_1.SafeDecimal(result).greaterThanOrEqualTo(gridPrice)) {
                    return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(result, symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
                }
            }
            const result = BinanceFutureMarginCalculator.getLiquidationPriceMatchMaintenances(avgOpenPrice, new trade_utils_lib_1.SafeDecimal(0), _fee, _marginRate, chargedMargin, maintenance, trend);
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(result, symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        }
        // if (trend === 'long') {
        //     // 看多最低价的时候为满仓, 因为逢低买入
        //     const baseAmount = _perVolume.mul(new SafeDecimal(row).sub(1))
        //     const result = this.getLiquidationPrice(curPrice, baseAmount, _fee, _marginRate, chargedMargin, esMaintenance, trend)
        //     return NumberCommonUtils.formatterDecimalToStr(result, symbol.precision, SafeDecimal.ROUND_CEIL)
        // } else {
        //     const price = priceArr[priceArr.length - 1];
        //     // 看空最高价的时候为满仓, 从最高0到负数
        //     const curPriceIndex = GridTradingUtils.findPriceIndexInArr(priceArr, curPrice.toString());
        //     let sumPrice: SafeDecimal = new SafeDecimal(0); // 当前价格向下的格子挂买单的格子的价格总和
        //     for (let i = 0; i < curPriceIndex; i++) {
        //         sumPrice = sumPrice.add(priceArr[i]);
        //     }
        //     const downPosition = curPrice.mul(new SafeDecimal(priceArr.length).sub(1).sub(curPriceIndex));
        //     const baseAmount = sumPrice.mul(_perVolume).add(curPrice.mul(new SafeDecimal(priceArr.length).sub(1).sub(curPriceIndex)));
        //     const result = this.getLiquidationPrice(curPrice, baseAmount, _fee, _marginRate, chargedMargin, esMaintenance, trend)
        //     return NumberCommonUtils.formatterDecimalToStr(result, symbol.precision, SafeDecimal.ROUND_DOWN)
        // }
    }
}
exports.BinanceFutureMarginCalculator = BinanceFutureMarginCalculator;
